import brazil from '@/data/verifyBusiness-BR';
import { ParentStep } from '@/types/steps';

export const useVerifyBusinessSteps = (): readonly ParentStep<any>[] => {
  return brazil;
};
